const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* ----- Intersection Observer Animations ----- */
var animateItem = document.querySelectorAll(".animate")

const intObserver = new IntersectionObserver(entries => {
	entries.forEach(entry => {
		entry.target.classList.toggle("show", entry.isIntersecting)
	})
})

animateItem.forEach(animate => {
	intObserver.observe(animate)
})

const mutObserver = new MutationObserver((mutations, observer) => {
  // console.log(mutations);
  animateItem = document.querySelectorAll(".animate")
  animateItem.forEach(animate => {
    intObserver.observe(animate)
  })
});

mutObserver.observe(document, {
  subtree: true,
  attributes: true,
  childList: true
});